import { render, staticRenderFns } from "./PerfScore.vue?vue&type=template&id=177df1da"
import script from "./PerfScore.vue?vue&type=script&lang=js"
export * from "./PerfScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports